export interface ProgressBarProps {
  /** Items done. */
  value: number;
  /** Total items. `0` renders an empty track. */
  max: number;
  /** Left-hand caption, e.g. "Verified". */
  label?: string;
  /** Show the "12 / 87" counter on the right. Default true. */
  showCount?: boolean;
  className?: string;
}

/**
 * Progress indicator used by Verify (12/87), Correct and the task cards.
 * Exposed as an ARIA progressbar so screen readers announce the ratio.
 */
export function ProgressBar({ value, max, label, showCount = true, className = '' }: ProgressBarProps) {
  const safeMax = Math.max(0, max);
  const safeValue = Math.min(Math.max(0, value), safeMax);
  const pct = safeMax === 0 ? 0 : (safeValue / safeMax) * 100;

  return (
    <div className={`progress ${className}`.trim()}>
      <div
        className="progress__track"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={safeMax}
        aria-valuenow={safeValue}
        aria-label={label ?? 'Progress'}
      >
        <div className="progress__fill" style={{ width: `${pct}%` }} />
      </div>
      {(label || showCount) && (
        <div className="progress__label">
          <span>{label}</span>
          {showCount && (
            <span className="mono">
              {safeValue} / {safeMax}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
